import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/logo.svg'
import _imports_1 from '@/assets/images/home/arrow-right.svg'
import _imports_2 from '@/assets/images/home/Vector.svg'
import _imports_3 from '@/assets/images/home/chat.svg'
import _imports_4 from '@/assets/images/home/scroll_up.svg'


const _hoisted_1 = {
  id: "as-footer",
  ref: "as-footer",
  class: "footer__inner white-text"
}
const _hoisted_2 = { class: "container-fluid py-5" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-xs-6 col-md-4 text-center text-md-start" }
const _hoisted_6 = { class: "as-footer-box" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "mb-3",
  width: "234",
  height: "70",
  src: _imports_0,
  "data-aos": "flip-down",
  "data-aos-easing": "ease-out-cubic",
  "data-aos-duration": "2000",
  alt: "Benefit"
}, null, -1)
const _hoisted_8 = { class: "light-blue" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "col-xs-6 col-md-2 text-center text-md-start" }
const _hoisted_11 = { class: "as-footer-box" }
const _hoisted_12 = { class: "my-3 hc6 bold white-text" }
const _hoisted_13 = { class: "list-unstyled" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid mr-2 hide-mobile",
  src: _imports_1,
  alt: "footer"
}, null, -1)
const _hoisted_15 = { href: "/privacy_policy" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid mr-2 hide-mobile",
  src: _imports_1,
  alt: "footer"
}, null, -1)
const _hoisted_17 = { href: "/terms" }
const _hoisted_18 = { class: "col-xs-6 col-md-2 text-center text-md-start" }
const _hoisted_19 = { class: "as-footer-box" }
const _hoisted_20 = { class: "my-3 hc6 bold white-text" }
const _hoisted_21 = { class: "list-unstyled" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid mr-2 hide-mobile",
  src: _imports_1,
  alt: "footer"
}, null, -1)
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid mr-2 hide-mobile",
  src: _imports_1,
  alt: "footer"
}, null, -1)
const _hoisted_26 = { href: "/tutorials?p=2" }
const _hoisted_27 = { class: "col-xs-6 col-md-3 text-center text-md-start text-center" }
const _hoisted_28 = { class: "my-3 hc6 bold white-text" }
const _hoisted_29 = { class: "container text-center" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-12 text-center text-lg-start px-0" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid me-2",
  width: "32",
  height: "32",
  src: _imports_2,
  alt: "client"
}, null, -1)
const _hoisted_33 = { class: "btn-image-align-inline" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = { class: "container-fluid footer-below text-center text-lg-start" }
const _hoisted_36 = { class: "container" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("hr", { class: "hr-bg" }, null, -1)
const _hoisted_39 = { class: "col-12 col-md-4 text-footer-1" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" © ")
const _hoisted_41 = { href: "" }
const _hoisted_42 = { class: "fixed-service" }
const _hoisted_43 = { class: "tooltip-container" }
const _hoisted_44 = ["href"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "img-fluid fixed-service-icon mainImg mb-3",
  alt: "chat icon"
}, null, -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { id: "scrollTop" }
const _hoisted_48 = { class: "tooltip-container" }
const _hoisted_49 = {
  key: 0,
  class: "fixed-service-circle"
}
const _hoisted_50 = {
  key: 0,
  class: "tooltip tooltip-bottom hide-on-mobile"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Fade = _resolveComponent("Fade")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("footer", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createElementVNode("p", _hoisted_8, [
                  _createTextVNode(_toDisplayString($setup.locale.footer10) + " ", 1),
                  _hoisted_9,
                  _createTextVNode(" " + _toDisplayString($setup.locale.footer25), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h3", _hoisted_12, _toDisplayString($setup.locale.footer11), 1),
                _createElementVNode("ul", _hoisted_13, [
                  _createElementVNode("li", null, [
                    _hoisted_14,
                    _createElementVNode("a", _hoisted_15, _toDisplayString($setup.locale.footer13), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_16,
                    _createElementVNode("a", _hoisted_17, _toDisplayString($setup.locale.footer14), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("h3", _hoisted_20, _toDisplayString($setup.locale.footer15), 1),
                _createElementVNode("ul", _hoisted_21, [
                  ($setup.supportLink)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("a", { href: $setup.supportLink }, _toDisplayString($setup.locale.footer16), 9, _hoisted_24)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", null, [
                    _hoisted_25,
                    _createElementVNode("a", _hoisted_26, _toDisplayString($setup.locale.footer17), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("h3", _hoisted_28, _toDisplayString($setup.locale.footer19), 1),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, [
                      _createTextVNode(_toDisplayString($setup.locale.footer20), 1),
                      _hoisted_34,
                      _createTextVNode(" " + _toDisplayString($setup.locale.footer21), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("p", null, [
                _hoisted_40,
                _createElementVNode("a", _hoisted_41, _toDisplayString($setup.data.current_year) + " " + _toDisplayString($setup.locale.footer22), 1)
              ])
            ])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_component_Fade, null, {
              default: _withCtx(() => [
                ($setup.supportLink)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: $setup.supportLink,
                      class: "open-share-modal fixed-service-circle",
                      "data-modal": "#share",
                      onMouseover: _cache[0] || (_cache[0] = ($event: any) => ($setup.showTooltip(1))),
                      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => ($setup.hideTooltip(1)))
                    }, _hoisted_46, 40, _hoisted_44))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("li", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_Fade, null, {
              default: _withCtx(() => [
                ($setup.isVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createElementVNode("img", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.scrollToTop())),
                        src: _imports_4,
                        onMouseover: _cache[3] || (_cache[3] = ($event: any) => ($setup.showTooltip(2))),
                        onMouseleave: _cache[4] || (_cache[4] = ($event: any) => ($setup.hideTooltip(2))),
                        class: "img-fluid fixed-service-icon mainImg mb-3",
                        alt: "scroll icon"
                      }, null, 32)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            ($setup.isTooltipScrollVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString($setup.locale.footer24), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}